export default "__VITE_ASSET__9680636a__"